import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { FreudSwitchModule } from '@freud-ds/web-components';
import { TranslateModule } from '@ngx-translate/core';

import { UserToggleStatusModalModule } from '../user-toggle-status-modal/user-toggle-status-modal.module';
import { UserToggleStatusComponent } from './user-toggle-status.component';

@NgModule({
	declarations: [UserToggleStatusComponent],
	imports: [
		CommonModule,
		FreudSwitchModule,
		FormsModule,
		TranslateModule,
		UserToggleStatusModalModule,
	],
	exports: [UserToggleStatusComponent],
	providers: [],
})
export class UserToggleStatusModule {}
